/* eslint-disable */
import React, { createContext, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import baseUrl from '~/services/base';
import 'react-toastify/dist/ReactToastify.css';
import { TokenContext } from './TokenContext';
import { apiLucree, apiPGM } from '~/services/api';
import PayloadParticipante from '../assets/styles/payloadDetalhamento/payloadDetalhamentoParticipanteExcel.json';
import PayloadIndustria from '../assets/styles/payloadDetalhamento/payloadDetalhamentoIndustriaExcel.json';
import PayloadRevenda from '../assets/styles/payloadDetalhamento/payloadDetalhamentoRevendaExcel.json';
import PayloadMeusCreditos from '../assets/styles/payloadsExtratoExcel/perfilExtratoMeusCreditos.json';



export const PGMContext = createContext([]);

export function PGMProvider(props) {
	const { children, user } = props;
	const [dataDetalhamento, setDataDetalhamento] = useState([]);
	const [loadingDetalhamento, setLoadingDetalhamento] = useState(false);
	const [loaderDownload, setLoaderDownload] = useState(false);

	const [loadingCreditos, setLoadingCreditos] = useState(false);
	const [dataCredito, setDataCredito] = useState([]);
	const [totalItemsCredito, setTotalItemsCredito] = useState(0);

	const [total, setTotal] = useState({
		creditados: 0,
		debitados: 0,
		credito: 0,
	});

	const { autenticacaoV1Token } = useContext(TokenContext);
	async function authToken() {
		let result = null;
		try {
			result = await autenticacaoV1Token();
		} catch (e) {
			console.error(e);
		}
		return result;
	}

	async function getDetalhamentoParticipante(params) {
		try {
			setLoadingDetalhamento(true)
			const response = await apiPGM.get(`/detalhamento/participante/v2`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${user.token.access}`,
					},
					params: params
				}).then(res => {
					setLoadingDetalhamento(false)
					if(res.data){
						const info = res.data;
						info.error = null
						setDataDetalhamento(info)
					}
				});
			return response;
		} catch (error) {
			setLoadingDetalhamento(false)
			let info = {error: "Detalhamento não carregado. Por favor atualize a página"}
			if(error?.response?.data?.message){
				info.error = error.response.data.message;
			}
			setDataDetalhamento(info)
			toast.error(info.error);
		}
		return null;
	}

	async function getDetalhamentoRevenda(params) {
		// page, data_transacao, documento_revenda, autorizacao, nsu, modalidade, excelQuery, hoje, semana
		try {
			setLoadingDetalhamento(true)
			const response = await apiPGM.get(`/detalhamento/revenda`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Accept': "*/*",
						'Authorization': `Bearer ${user.token.access}`,
					},
					params: params

				}).then(res => {
					setLoadingDetalhamento(false)
					if(res.data){
						const info = res.data;
						info.error = null
						setDataDetalhamento(info)
					}
				});
			return response;
		} catch (error) {
			setLoadingDetalhamento(false)
			let info = {error: "Detalhamento não carregado. Por favor atualize a página"}
			
			if(error?.response?.data?.message){
				info.error = error.response.data.message;
			}
			setDataDetalhamento(info)
			toast.error(info.error);
		}
		return null;
	}

	async function getDetalhamentoIndustria(params) {
		// page, data_transacao, documento_revenda, autorizacao, nsu, modalidade, excelQuery, hoje, semana
		try {
			setLoadingDetalhamento(true)
			const response = await apiPGM.get(`/detalhamento/industria`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Accept': "*/*",
						'Authorization': `Bearer ${user.token.access}`,
					},
					params: params

				}).then(res => {
					setLoadingDetalhamento(false)
					if(res.data){
						const info = res.data;
						info.error = null
						setDataDetalhamento(info)
					}
					return res;
				});
			return response;
		} catch (error) {
			setLoadingDetalhamento(false)
			let info = {error: "Detalhamento não carregado. Por favor atualize a página"}
			if(error?.response?.data?.message){
				info.error = error.response.data.message;
			}
			setDataDetalhamento(info)
			toast.error(info.error);
			return null;
		}

	}

	async function getCupom(doc, token) {
		try {
			const response = await apiLucree.get(`/hierarquiav2/entidades/`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Accept': "*/*",
						'Authorization': token,
					},
					params: {
						documento: doc
					}

				}).then(res => {
					return res;
				});

			return response;
		} catch (error) {
			return null;
		}

	}

	async function getExportDetalhamento(params, permissao) {
		setLoaderDownload(true);
		try {
			const url = `${baseUrl.pgm}/detalhamento/${permissao === 'Revenda' ? 'revenda' : 'participante/v2'}?items=${params.items ? params.items : 1500}&excelQuery=true&data_transacao=${params.data_transacao ? params.data_transacao : ''}`
			const dataPath = ".dados";

			const payload = {
				logo: 'lucree',
				sheet_name: 'Planilha Lucree',
				request: {
					data_path: dataPath,
					url: url,
					headers: {
						Authorization: `Bearer ${user.token.access}`,
					}
				},
				styles: [
					{
						name: "bold",
						bold: true
					},
					{
						name: "date",
						num_format: "DD/MM/YYYY"
					},
					{
						name: "money",
						num_format: "#,##0.00;[RED]-#,##0.00"
					}
				],
				format: permissao === 'Revenda' ? PayloadRevenda : (user.dados.cargo.toLowerCase() === 'industria' ? PayloadIndustria : PayloadParticipante),
			};

			download(payload, "detalhamentoLucree.xlsx");
		} catch (error) {
			setLoadingDetalhamento(false);
			setLoaderDownload(false);
			console.log('Erro no Download Export.');
		}
	}

	async function getExportMeusCreditos(paramsDate) {
		setLoaderDownload(true);
		try {
			const url = `${baseUrl.pgm}/creditos`
			const dataPath = ".dados";

			const payload = {
				logo: 'lucree',
				sheet_name: 'Planilha Lucree',
				request: {
					data_path: dataPath,
					url: url,
					headers: {
						Authorization: `Bearer ${user.token.access}`,
					},
					params: {
						page: 1,
						items: 30000,
						init_date: paramsDate?.dateInit,
						end_date: paramsDate?.dateEnd,
					}
				},
				styles: [
					{
						name: "bold",
						bold: true
					},
					{
						name: "date",
						num_format: "DD/MM/YYYY"
					},
					{
						name: "money",
						num_format: "#,##0.00;[RED]-#,##0.00"
					}
				],
				format: PayloadMeusCreditos,
			};

			download(payload, "meusCreditosLucree.xlsx");
		} catch (error) {
			setLoadingCreditos(false);
			setLoaderDownload(false);
			console.log('Erro no Download Export.');
		}
	}

	async function download(data, name) {
		var oReq = new XMLHttpRequest();
		oReq.open("POST", "https://api.grupoe2f.com.br/export/export", true);
		oReq.responseType = "blob";
		oReq.setRequestHeader("Content-Type", "application/json");

		let link = document.createElement('a');

		oReq.onload = function (oEvent) {
			var blob = oReq.response;
			link.setAttribute("download", name);
			link.href = URL.createObjectURL(blob);
			// window.location.href = link.href;
			link.setAttribute("href", URL.createObjectURL(blob))
			document.body.appendChild(link)
			link.click();

			setLoaderDownload(false)
		};

		oReq.send(JSON.stringify(data));
	}

	async function getMeusCreditos(paramsDate, page = 1, items = 10) {
		try {
			setLoadingCreditos(true)
			const response = await apiPGM.get(`/creditos`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Accept': "*/*",
						'Authorization': `Bearer ${user.token.access}`,
					},
					params: {
						page,
						items,
						init_date: paramsDate?.dateInit,
						end_date: paramsDate?.dateEnd,
					}
				}).then(res => {
					setLoadingCreditos(false)
					if(res.data.dados){
						setTotalItemsCredito(res.data.total_registros || 0)
						setDataCredito(res.data.dados || [])
						setTotal({
							creditados: res.data.total_creditados || 0,
							debitados: res.data.total_debitados || 0,
							credito: res.data.total_credito || 0,
						})
					}
				});
			return response;
		} catch (error) {
			setLoadingCreditos(false)
			const info = {error: "'Meu Extrato de Crédito' não carregado. Por favor atualize a página"}
			setDataCredito(info)
			toast.error(
				"'Meu Extrato de Crédito' não carregado. Por favor atualize a página."
			);
		}
		return null;
	}

	return (
		<PGMContext.Provider
			value={{
				loaderDownload,
				authToken,
				total,
				dataCredito,
				dataDetalhamento,
				setDataDetalhamento,
				setLoaderDownload,
				setLoadingCreditos,
				loadingDetalhamento,
				loadingCreditos,
				getExportMeusCreditos,
				totalItemsCredito,
				getExportDetalhamento,
				setLoadingDetalhamento,
				getDetalhamentoParticipante,
				getDetalhamentoRevenda,
				getMeusCreditos,
				getDetalhamentoIndustria,
				getCupom,
			}}>
			{children}
		</PGMContext.Provider>
	);
}
